module.exports = __webpack_public_path__ + "static/media/Boat.177e077c.svg";